import COUNTRIES from '@data/countries'

const AVOID_LABELS = {
    motorway: 'Autobahnen vermeiden',
    vignette: 'Vignettenpflicht vermeiden',
    toll: 'Mautstraßen vermeiden',
    ferry: 'Fähren vermeiden',
    STAIRS: 'Treppen vermeiden',
    ELEVATOR: 'Aufzüge vermeiden',
    ESCALATOR: 'Rolltreppen vermeiden',
}

const OTHER_LABELS = {
    bikeCarriage: 'Fahrradmitnahme möglich'
}

export function getAvoidLabel(type) {
    return AVOID_LABELS[type] ?? false
}

export function getOtherSettingsLabel(type) {
    return OTHER_LABELS[type] ?? false
}

export function getCountryName(code) {
    const foundCountry = COUNTRIES.filter(country => country.value === code)
    return foundCountry && foundCountry.length ? foundCountry[0].label : false
}